import React, { Component } from "react";
import "./style.css";
import "../../../index.css";
class SchoolHeader extends Component {
  render() {
    const { visible, num } = this.props;
    return (
      <div
        className={
          visible === true
            ? "school_header_box"
            : "school_header_box display_none"
        }
      >
        {num === null ? (
          <div>
            这里仅展示了<span>在浙招生</span>的大学
          </div>
        ) : (
          <div>
            符合的学校<span>{num}</span>所
          </div>
        )}
      </div>
    );
  }
}

export default SchoolHeader;



// WEBPACK FOOTER //
// ./src/components/School/SchoolHeader/index.js